import { inject, InjectionToken, Provider } from '@angular/core';

export interface ChatConfiguration {
	showOptions: boolean;
	canInteract: boolean;
	lateralChatTheme: boolean;
	withNodeCreation: boolean;
}

export const defaultChatConfiguration: ChatConfiguration = {
	showOptions: true,
	canInteract: true,
	lateralChatTheme: false,
	withNodeCreation: false,
};

export const CHAT_CONFIGURATION = new InjectionToken<ChatConfiguration>('CHAT_NODE_ROUTER_LINK', {
	factory: () => defaultChatConfiguration,
});

export const provideChatConfiguration = (config: Partial<ChatConfiguration>): Provider => {
	return {
		provide: CHAT_CONFIGURATION,
		useValue: {
			...defaultChatConfiguration,
			...config,
		},
	};
};

export const injectChatConfiguration = (): ChatConfiguration => {
	return inject(CHAT_CONFIGURATION);
};
